import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Box, CircularProgress } from '@mui/material';
import type { ReactNode } from 'react';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!user.isAdmin) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <h2>权限不足</h2>
        <p>此管理后台仅限管理员访问。</p>
        <p>如需管理员权限，请联系系统管理员将您的群晖账号加入 administrators 组。</p>
      </Box>
    );
  }

  return <>{children}</>;
}
